export default "__VITE_ASSET__Di0UUanE__"